<template>
  <div>
    <div class="progressbar" :style="{width: loadedPercent+'%', opacity: loadedPercent>0?1:0}"></div>
    <div class="question-block">
      <div class="question-block__hide" @click="isHidden=!isHidden">
        <font-awesome-icon icon="angle-up" v-show="!isHidden"/>
        <font-awesome-icon icon="angle-down" v-show="isHidden"/>
      </div>
      <div class="question" :class="{hidden: isHidden}">
        <div class="question__id">
          {{question.id}}
        </div>
        <div class="question__name">
          <span class="label">Текст</span>
          <p class="text-w-label">
            <vue-editor
              style="max-height:350px; overflow-y: auto;"
              v-model="question.text"
              @text-change="debounce(question)"
              :editorToolbar="customToolbar"
            ></vue-editor>
          </p>
        </div>
        <div class="question__situation">
          <span class="label">Ситуация</span>

          <p class="text-w-label">
            <SmartInput v-model="question.situation" @change="onQuestionChange(question)"/>
          </p>

        </div>
        <div>
          <span class="label">Изображение</span>
          <div class="question__image">
            <a :href="question.image" target="_blank"
               class="question__image-icon"
               v-show="question.image.length"
               title="Открыть изображение">
              <font-awesome-icon icon="image"/>
            </a>
            <p class="ellipsis">
              <SmartInput v-model="question.image" @change="onQuestionChange(question)" placeholder="Вставьте ссылку на изображение"/>
            </p>
          </div>
        </div>
        <div class="btn btn-light" @click="deleteQuestion(question.id)">
          <font-awesome-icon icon="trash"/>
          Удалить вопрос
        </div>
      </div>
      <div class="answers" :class="{hidden: isHidden}">
        <div class="answer" v-for="answer in question.question_answers" :key="answer.id">
          <QuestionAnswer :answer="answer" :question="question" :onUploadProgress="onUploadProgress"/>
        </div>
        <div class="btn btn-light question__btn" v-show="!newAnswerMode" @click="toggleNewAnswerMode">
          <font-awesome-icon icon="plus"/>
          Добавить ответ
        </div>
        <div class="answer new-answer" v-show="newAnswerMode">
          <form @submit.prevent="createAnswer" class="flex-between">
            <input type="text" v-model="newAnswerText" ref="newAnswerInput">
            <div class="btn btn-light" @click="toggleNewAnswerMode">Отмена</div>
            <button class="btn" type="submit">Добавить</button>
          </form>
        </div>
      </div>
    </div>
    <ScrollToTop/>
  </div>
</template>

<script>
  import SmartInput from '@/components/SmartInput'
  import QuestionAnswer from '@/components/tests/QuestionAnswer'
  import ScrollToTop from '@/components/ScrollToTop'
  import QuestionsService from '@/services/QuestionsService'
  import { VueEditor } from 'vue2-editor'

  function debounce (func, timeout = 500) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => { func.apply(this, args) }, timeout)
  }
}

const processChange = debounce((question, func) => func(question))

  export default {
    name: 'TestQuestion',
    props: ['question'],
    components: {
      VueEditor,
      SmartInput,
      ScrollToTop,
      QuestionAnswer
    },
    data () {
      return {
        isHidden: false,
        loadedPercent: 0,
        newAnswerMode: false,
        newAnswerText: '',
        customToolbar: [
          [{ header: [false, 1, 2, 3, 4, 5, 6] }],
          ['bold', 'italic', 'underline'],
          [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ indent: '-1' }, { indent: '+1' }],
          ['link', 'image']
        ]
      }
    },
    computed: {
      testId () {
        return this.$store.getters.test.id
      }
    },
    methods: {
      debounce (question) {
        processChange(question, this.onQuestionChange)
      },
      show () {
        this.isHidden = false
      },
      hide () {
        this.isHidden = true
      },
      onUploadProgress (progressEvent) {
        this.loadedPercent = 100 / (progressEvent.total / progressEvent.loaded)
      },
      changeProgress (percent) {
        this.loadedPercent = percent
      },
      onQuestionChange (question) {
        QuestionsService.patchQuestion(this.testId, question, this.onUploadProgress).then(
          (response) => {
            this.$store.dispatch('setQuestion', question)
            this.loadedPercent = 0
          }
        )
      },
      deleteQuestion (questionId) {
        QuestionsService.deleteQuestion(this.$store.getters.test.id, questionId).then(
          (response) => {
            this.$store.dispatch('deleteQuestion', questionId)
          }
        )
      },
      toggleNewAnswerMode () {
        this.newAnswerText = ''
        this.newAnswerMode = !this.newAnswerMode
        if (this.newAnswerMode) {
          setTimeout(() => {
            this.$refs.newAnswerInput.focus()
          }, 70)
        }
      },
      createAnswer () {
        let answer = {
          text: this.newAnswerText,
          score: 0,
          success: true,
          next_question: null
        }
        QuestionsService.createAnswer(this.testId, this.question.id, answer, this.onUploadProgress).then(
          (response) => {
            answer = response
            this.$store.dispatch('addAnswerToQuestion', {answer, questionId: this.question.id})
            this.toggleNewAnswerMode()
            this.loadedPercent = 0
          }
        )
      }
    },
    mounted () {
    }
  }
</script>
<style>
.quillWrapper .ql-toolbar { position: -webkit-sticky; position: sticky; top: 0; z-index: 2; background-color: #fff; }
</style>
<style scoped lang="scss">
  .progressbar {
    height: 3px;
    min-width: 3px;
    background-color: $blue;
    transition: width 0.1s linear;
  }

  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /*word-break: e;*/
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .label {
    display: block;
    margin: 5px 0;
    text-transform: uppercase;
    color: $blue;
  }

  p {
    margin: 0;
  }

  .question-block {
    border: 1px solid $light-blue;
    padding: 20px 30px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    margin-bottom: 30px;
    position: relative;
    &__hide {
      position: absolute;
      top: 0;
      right: 0;
      padding: 0px 5px;
      font-size: 19px;
      cursor: pointer;
      height: 100%;
      path {
        fill: $light-blue;
      }
      &:hover path {
        fill: $blue;
      }
    }
  }

  .question {
    width: 40%;
    max-width: 40%;
    min-width: 40%;
    padding-right: 20px;
    position: relative;
    &__id {
      position: absolute;
      top: -35px;
      left: -45px;
      display: block;
      width: 35px;
      height: 35px;
      color: #fff;
      background-color: $blue;
      border-radius: 50%;
      font-size: 16px;
      text-align: center;
      line-height: 35px;
    }
    &__image {
      display: flex;
      align-items: center;
      p {
        flex: 1;
      }
    }
    &__image-icon {
      padding: 5px;
      border: 1px solid $light-blue;
      margin-right: 10px;
      path {
        fill: $blue;
      }
      &:hover {
        border: 1px solid $blue;
      }
    }
    > * {
      margin-bottom: 20px;
    }
    > *:last-child {
      margin-bottom: 0;
    }
    &.hidden {
      width: 100%;
      min-width: 100%;
      max-width: 100%;
      > * {
        display: none;
      }
      .question__id {
        display: block;
      }
      .question__name {
        margin: 0;
        .label {
          display: none;
        }
        display: block;
      }
    }
  }

  .answers {
    width: 60%;
    padding-left: 20px;
    border-left: 1px solid $light-blue;
    max-width: 100%;
    box-sizing: border-box;
    &.hidden {
      display: none;
    }
  }

  .new-answer {
    margin-bottom: 0;
    form {
      min-width: 100%;
    }
    input {
      flex: 1;
      font-size: 14px;
    }
    .btn {
      margin-left: 10px;
      padding: 7px 10px;
      font-size: 14px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/tests/TestQuestion.vue